import  { useState } from 'react';
import { MarketPlaceLinksList, MarketPlaceListItem, MarketPlaceLinkItem } from './styles';
import { useSelector } from 'react-redux';
import { getMarketplaceListingUrl } from '../../utils/helper';
import { useTranslatedObject } from '../../utils/translation';
import { FooterNavigationBar, sendGA4Data } from '../../analytics/events';
import { navigateToListingPage } from '@headless-shell/shared-components';

const Industries = ({ isMobileOrTablet, navigate }) => {
  const [expanded, setExpanded] = useState(false);
  const industry_categories = useTranslatedObject('industry_categories');
  const industry_facetType = useTranslatedObject('industry_facetType');
  const { locale = '' } = useSelector(state => state.app) || {};
  const industries = Object.keys(industry_categories);
  const visibleCount = isMobileOrTablet ? 5 : industries.length;
  const page = useTranslatedObject('page');
  const visibleItems = expanded ? industries : industries.slice(0, visibleCount);

  const onFooterIndustryClick = (industry) => {
    sendGA4Data(FooterNavigationBar, { eventCategory: "Industry", eventLabel: industry?.label });
  }

  const handleIndustryClick = (e, industry, hasAttribute, url) => {
      onFooterIndustryClick(industry);
      e.preventDefault();
      e.stopPropagation();
      if (!hasAttribute) {
        const listingUrl = navigateToListingPage(url);
        if (listingUrl?.includes('listing')) { 
          navigate(listingUrl);
        }
      }
      navigate(url);
  }

  return (
    <MarketPlaceLinksList id="industry-list">
       {visibleItems.map((key, i) => {
        const industry = industry_categories[key];
        const name = industry.label;
        const hasAttribute = !!industry.attributeId;
        const isOther = (name === 'Other' || String(key).toLowerCase() === 'other');
        const url = getMarketplaceListingUrl({
          locale,
          facetType: (!hasAttribute || isOther) ? industry_facetType : '',
          solutionName: key,
          attributeId: (hasAttribute && !isOther) ? industry.attributeId : '',
          page: hasAttribute ? (isOther ? 'listing' : page?.industry) : 'listing',
        });

        return (
          <MarketPlaceListItem id={`industry-list-item-${i}`} key={i}>
            <MarketPlaceLinkItem
              aria-label={name}
              id={`industry-link-item-${name}`}
              href={url}
              onClick={(e) => handleIndustryClick(e, industry, hasAttribute, url)}>
              {name}
            </MarketPlaceLinkItem>
          </MarketPlaceListItem>
        );
      })}

      {isMobileOrTablet && industries.length > visibleCount && !expanded && (
        <MarketPlaceListItem key="toggle" id="show-more-industries-list">
          <MarketPlaceLinkItem
           aria-label={'Show more industries'}
           id="show-more-industries"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(!expanded);
            }}
          >
           Show more
          </MarketPlaceLinkItem>
        </MarketPlaceListItem>
      )}
    </MarketPlaceLinksList>
  );
};

export default Industries;